// extracted by mini-css-extract-plugin
export default {"backdrop":"SearchModal_backdrop__xYy5B","modal":"SearchModal_modal__BKuSF","slide-down":"SearchModal_slide-down__rHPvo"};